import { render, staticRenderFns } from "./RD.vue?vue&type=template&id=06e23294&scoped=true&"
import script from "./RD.vue?vue&type=script&lang=js&"
export * from "./RD.vue?vue&type=script&lang=js&"
import style0 from "./RD.vue?vue&type=style&index=0&id=06e23294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e23294",
  null
  
)

export default component.exports